module.exports = __webpack_public_path__ + "static/media/skincare-prod4.585ddb5c.png";